import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import Logo from '../../assets/Logo.png'
import { View, ScrollView } from 'react-native';
import { useNavigate } from 'react-router-dom';
import { StyleSheet, TouchableOpacity, Text } from 'react-native';
import { Page1 } from '../Pages/QuizPages/page1NameLocation';
import { Page2 } from '../Pages/QuizPages/page2SkinType';
import { Page3 } from '../Pages/QuizPages/page3Age';
import { Page4 } from '../Pages/QuizPages/page4SkinTone';
import { Page5 } from '../Pages/QuizPages/page5NewProductIrritation';
import { Page6 } from '../Pages/QuizPages/page6NewProductBreakOut';
import { Page7 } from '../Pages/QuizPages/page7Concerns';
import { Page8 } from '../Pages/QuizPages/page8WrinkleConcerns';
import { Page9 } from '../Pages/QuizPages/page9AcneConcerns';
import { Page10 } from '../Pages/QuizPages/page10DrynessConcerns';
import { Page11 } from '../Pages/QuizPages/page11SkinGoals';
import { Page12 } from '../Pages/QuizPages/page12Sleep';
import { Page13 } from '../Pages/QuizPages/page13Water';
import { Page14 } from '../Pages/QuizPages/page14Sunlight';
import { Page15 } from '../Pages/QuizPages/page15Stress';
import { Page16 } from '../Pages/QuizPages/page16ExistingProducts';
import { Page17 } from '../Pages/QuizPages/page17Email';
import { ResultsPage } from './ResultsPage';

export function Home() {

  const navigate = useNavigate();

  const [fields, setFormData] = useState({
    id: '',
    name: '',
    zipcode: '',
    skintype: '',
    age: '',
    skintone: '',
    new_product_irritation: '',
    new_product_breakout: '',
    skin_concerns: '',
    wrinkle_concerns: '',
    acne_concerns: '',
    dryness_concerns: '',
    skin_goals: '',
    sleep_hours: '',
    average_water: '',
    sunlight_hours: '',
    stress_level: '',
    current_products: '',
    email: '',
    promotionalConsent: false
  });

  const [componentIndex, setComponentIndex] = useState(0);
  const fieldNames = Object.keys(fields);

  const components = [
    Page1,
    Page2,
    Page3,
    Page4,
    Page5,
    Page6,
    Page7, //come back
    Page8,
    Page9,
    Page10,
    Page11, //come back
    Page12,
    Page13,
    Page14,
    Page15,
    Page16,
    Page17,
    ResultsPage
  ];

  const isSubmitComponent = componentIndex === components.length - 2;

  const [step, setStep] = useState(0);

  const labels = [
    "Please tell us about yourself",
    "Biology",
    "Biology",
    "Biology",
    "Biology",
    "Biology",
    "Lifestyle",
    "Concerns",
    "Concerns",
    "Concerns",
    "Lifestyle",
    "Lifestyle",
    "Lifestyle",
    "Lifestyle",
    "Lifestyle",
    "Lifestyle",
    "Your formula is ready!"
  ]

  const [questions, setQuestions] = useState([
    "",
    "What is your skin type?",
    "What is your age?",
    "How would you describe your skin tone?",
    "Does your skin become irritated when trying new products?",
    "When trying new skin care products, does your skin tend to break out?",
    "What are your skin care concerns? Select all that apply.",
    "How concerned are you with lines or wrinkles on your face?",
    "How concerned are you with acne?",
    "How concerned are you with skin dryness?",
    "What are your skin goals?",
    "On average, how many hours do you sleep per night?",
    "On average, how much water do you consume per day?",
    "On average, how many hours do you spend exposed to direct sunlight per day?",
    "How stressed are you?",
    "Which products do you currently use in your routine?",
    "Where should we send your results?",
  ])

  const scrollViewRef = useRef(null);

  const getResults = async (fields) => {
    try {
      const response = await fetch('https://adapted-backend.herokuapp.com/postForm', {
        method: 'POST',
        headers: {
          "Accept": "*/*",
          "Content-Type": "application/json",
          "Connection": "keep-alive",
        },
        body: JSON.stringify(fields),
        mode: 'cors' // Set mode to 'cors'
      });
  
      if (!response.ok) {
        throw new Error('Request failed');
      }
  
      const data = await response.json().catch((response) => { AlertIOS.alert(response)});
      return data;
    } catch (error) {
      console.error(error);
      throw error; // Rethrow the error to be caught in the caller function
    }
  };
  

  const handleClick = (name, value) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: prevFormData[name] === value ? '' : value
    }));
    console.log(fields)
  };

  const handleSubmit = async () => {

    if(!isValidEmail(fields.email.emailValue)){
      setQuestions([
        "Please enter a valid name and zipcode",
        "What is your skin type?",
        "What is your age?",
        "How would you describe your skin tone?",
        "Does your skin become irritated when trying new products?",
        "When trying new skin care products, does your skin tend to break out?",
        "What are your skin care concerns? Select all that apply.",
        "How concerned are you with lines or wrinkles on your face?",
        "How concerned are you with acne?",
        "How concerned are you with skin dryness?",
        "What are your skin goals?",
        "On average, how many hours do you sleep per night?",
        "On average, how much water do you consume per day?",
        "On average, how many hours do you spend exposed to direct sunlight per day?",
        "How stressed are you?",
        "Which products do you currently use in your routine?",
        "Please enter a valid email",
      ])
    }
    else{
      setQuestions([
        "Please enter a valid name and zipcode",
        "What is your skin type?",
        "What is your age?",
        "How would you describe your skin tone?",
        "Does your skin become irritated when trying new products?",
        "When trying new skin care products, does your skin tend to break out?",
        "What are your skin care concerns? Select all that apply.",
        "How concerned are you with lines or wrinkles on your face?",
        "How concerned are you with acne?",
        "How concerned are you with skin dryness?",
        "What are your skin goals?",
        "On average, how many hours do you sleep per night?",
        "On average, how much water do you consume per day?",
        "On average, how many hours do you spend exposed to direct sunlight per day?",
        "How stressed are you?",
        "Which products do you currently use in your routine?",
        "Calculating Results!",
      ])
      fields.promotionalConsent = fields.promotionalConsent.isChecked
      fields.name = fields.name.nameValue
      fields.zipcode = fields.zipcode.zipcode
      fields.email = fields.email.emailValue

      try {
        let id = await getResults(fields);
        navigate('/results/' + id);
      } catch (error) {
        console.error(error);
      }
    }
  };

  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  function isValidZipCode(zipCode) {
    // Regular expression pattern for ZIP code validation
    var zipCodePattern = /^\d{5}(?:[-\s]\d{4})?$/;

    return zipCodePattern.test(zipCode);
  }

  const toggleComponent = (x) => {
    console.log(fields[fieldNames[componentIndex+2]])
    scrollViewRef.current.scrollTo({ x: 0, y: 0, animated: true });
    if (componentIndex === 0) {
      if (fields.name.nameValue === '' || !isValidZipCode(fields.zipcode.zipcode)) {
        setQuestions([
          "Please enter a valid name and zipcode",
          "What is your skin type?",
          "What is your age?",
          "How would you describe your skin tone?",
          "Does your skin become irritated when trying new products?",
          "When trying new skin care products, does your skin tend to break out?",
          "What are your skin care concerns? Select all that apply.",
          "How concerned are you with lines or wrinkles on your face?",
          "How concerned are you with acne?",
          "How concerned are you with skin dryness?",
          "What are your skin goals?",
          "On average, how many hours do you sleep per night?",
          "On average, how much water do you consume per day?",
          "On average, how many hours do you spend exposed to direct sunlight per day?",
          "How stressed are you?",
          "Which products do you currently use in your routine?",
          "Where should we send your results?",
        ])
        }
       else {
        setComponentIndex((prevIndex) => prevIndex + x);
        setStep((prevStep) => prevStep + x);
      }
    }
    else if (fields[fieldNames[componentIndex+2]] == "" && x == 1){
      console.log('here')
      setQuestions([
        "Please enter a valid name and zipcode",
        "What is your skin type? Please select an option.",
        "What is your age? Please select an option.",
        "Please enter your skin tone? Please select an option.",
        "Does your skin become irritated when trying new products? Please select an option.",
        "When trying new skin care products, does your skin tend to break out? Please choose an option.",
        "What are your skin care concerns? Please enter a skin concern.",
        "How concerned are you with lines or wrinkles on your face? Please select an option.",
        "How concerned are you with acne? Please select an option.",
        "How concerned are you with skin dryness? Please select an option.",
        "What are your skin goals? Please select an option.",
        "On average, how many hours do you sleep per night? Please select an option.",
        "On average, how much water do you consume per day? Please select an option.",
        "On average, how many hours do you spend exposed to direct sunlight per day? Please select an option.",
        "How stressed are you? Please select an option.",
        "Which products do you currently use in your routine? Please select an option.",
        "Where should we send your results?",
      ])
    }
     else {
      setQuestions([    
      "",
      "What is your skin type?",
      "What is your age?",
      "How would you describe your skin tone?",
      "Does your skin become irritated when trying new products?",
      "When trying new skin care products, does your skin tend to break out?",
      "What are your skin care concerns? Select all that apply.",
      "How concerned are you with lines or wrinkles on your face?",
      "How concerned are you with acne?",
      "How concerned are you with skin dryness?",
      "What are your skin goals?",
      "On average, how many hours do you sleep per night?",
      "On average, how much water do you consume per day?",
      "On average, how many hours do you spend exposed to direct sunlight per day?",
      "How stressed are you?",
      "Which products do you currently use in your routine?",
      "Where should we send your results?",])
      setComponentIndex((prevIndex) => prevIndex + x);
      setStep((prevStep) => prevStep + x);
    }
  };


  const CurrentComponent = components[componentIndex];

  return (
    <View style={styles.container}>
      <View style={styles.center}>
        <img src={Logo} style={styles.image} />
      </View>
      <View style={styles.title}>
        <Text style={styles.titleText}>{labels[step]}</Text>
      </View>
      <View style={styles.question}>
        <Text style={styles.questionText}> {questions[step]}</Text>
      </View>

      <View style={styles.componentContainer}>
        <ScrollView
          //ref={(ref) => {this.scrollView = ref}}
          ref={scrollViewRef}
          contentContainerStyle={{ padding: 20 }}
          scrollIndicatorInsets={{ right: 10, top: 10, bottom: 10, left: 10 }}
          showsVerticalScrollIndicator={true}
          indicatorStyle={{ backgroundColor: '#3B1C15', width: 10 }}
          style={styles.componentScroll}>

          <View style={styles.component}>
            <CurrentComponent handleClick={handleClick} />
          </View>
        </ScrollView>
      </View>

      <View>
        {isSubmitComponent ? (
          <TouchableOpacity
            style={[styles.nextButton]}
            onPress={() => handleSubmit()}
          >
            <Text style={styles.buttonText}>Submit</Text>
          </TouchableOpacity>
        ) : componentIndex === 0 ? (
          <TouchableOpacity
            style={[styles.nextButton]}
            onPress={() => toggleComponent(1)}
          >
            <Text style={styles.buttonText}>Next</Text>
          </TouchableOpacity>
        ) : (
          <View style={styles.buttonContainer}>
            <TouchableOpacity
              style={[styles.backButton]}
              onPress={() => toggleComponent(-1)}
            >
              <Text style={styles.buttonText}>Back</Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={[styles.backButton]}
              onPress={() => toggleComponent(1)}
            >
              <Text style={styles.buttonText}>Next</Text>
            </TouchableOpacity>
          </View>
        )}
      </View>

    </View>
  );
}

const styles = StyleSheet.create({
  image: {
    position: 'fixed',
    top: 0,
    height: '14%',
    padding: 30,
  },
  title: {
    //display: 'flex',
    display: 'absolute',
    alignItems: 'center',
    position: 'fixed',
    top: '20%',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '100%',
    height: '100%'
  },
  question: {
    //margin: 6,
    display: 'flex',
    alignItems: 'center',
    position: 'fixed',
    //margin: 2,
    top: '28%',
    left: '50%',
    transform: 'translateX(-50%)',
    width: '100%',
  },
  titleText: {
    color: '#3B1C15',
    fontSize: 30,
    fontWeight: 'bold',
    fontFamily: 'DM Serif Display',
  },
  questionText: {
    color: '#3B1C15',
    fontSize: 20,
    maxWidth: '100%',
    textAlign: 'center',
    fontFamily: 'DM Sans',
  },
  code: {
    marginTop: 12,
    padding: 12,
    borderRadius: 8,
    color: '#666',
    backgroundColor: '#eaeaea',
  },
  center: {
    display: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 50
  },

  componentContainer: {
    position: 'fixed',
    top: '40%',
    left: 0,
    right: 0,
    bottom: '10%',
    width: '100%',
    padding: 10
  },
  componentScroll: {
    flex: 1,
  },
  component: {
    marginTop: 10,
    width: "100%",
    // alignItems: 'center', // center horizontally
    justifyContent: 'center', // center vertically
  },
  buttonText: {
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  nextButton: {
    backgroundColor: '#D6C2AA',
    //padding: 2,
    borderRadius: 5,
    borderWidth: 4,
    borderColor: '#D6C2AA',
    position: 'fixed',
    width: 300,
    bottom: '2%',
    left: '50%',
    transform: 'translateX(-50%)',
    fontFamily: 'DM Serif Display',
  },
  backButton: {
    backgroundColor: '#D6C2AA',
    borderRadius: 5,
    borderWidth: 4,
    borderColor: '#D6C2AA',
    width: 150,
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 2,
    fontFamily: 'DM Serif Display',
  },
  container: {
    position: 'fixed',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    position: 'fixed',
    bottom: '2%',
    left: '50%',
    transform: 'translateX(-50%)',
  },
});


//post to workpress
// const header = {
    //   'Authorization': "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2pwNC5hMDEubXlmdHB1cGxvYWQuY29tIiwiaWF0IjoxNjgwMjA5MzcwLCJuYmYiOjE2ODAyMDkzNzAsImV4cCI6MTY4MDgxNDE3MCwiZGF0YSI6eyJ1c2VyIjp7ImlkIjoiMiJ9fX0.ksmGXi41rhdtBrkiZaOYyC1XRj6htTA7UsZb576u7sg",
    //   'Content-Type': 'application/json'
    // }
    // axios
    //   .post("https://jp4.a01.myftpupload.com/wp-json/wp/v2/quizentries?orderby=modified",
    //     QuizPost, {
    //     headers: {
    //       'Authorization': "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2pwNC5hMDEubXlmdHB1cGxvYWQuY29tIiwiaWF0IjoxNjgwMjA5MzcwLCJuYmYiOjE2ODAyMDkzNzAsImV4cCI6MTY4MDgxNDE3MCwiZGF0YSI6eyJ1c2VyIjp7ImlkIjoiMiJ9fX0.ksmGXi41rhdtBrkiZaOYyC1XRj6htTA7UsZb576u7sg",
    //       'Content-Type': 'application/json'
    //     }
    //   }
    //   )
    //   .then((response) => {
    //     console.log("Form data submitted:", response.data);
    //   })
    //   .catch((error) => {
    //     console.error("Error submitting form data:", error);
    //   });
    // const body = JSON.stringify({ fields })
    // const response = await fetch("http://localhost:3000/getResults", {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json"
    //   },
    //   body: body
    // });

    // const data = await response.json();
    // console.log(data)